import React, {
  useEffect,
  useState,
  useImperativeHandle,
  forwardRef,
  useRef,
} from "react";
import { ProductCardProps } from "./ProductCard";
import { CaretDownOutlined, CaretUpOutlined } from "@ant-design/icons";

export interface CounterRef {
  setInputValue: (qty: string) => void;
  clearInput?: () => void;
  focus?: () => void;
}

const CartCounter = forwardRef<CounterRef, ProductCardProps>((props, ref) => {
  const { product } = props;
  const [quantityV, setQuantityV] = useState<any>("1");
  const { priceStatus } = product;
  const [focused, setFocused] = useState(false);
  const orderable = !!priceStatus ? false : true;
  const inputRef = useRef(null);

  useEffect(() => {
    console.log("quantity", quantityV);
    if (!quantityV || quantityV === "0") {
      product.shoppingQty = 0;
    } else {
      product.shoppingQty = parseInt(quantityV);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quantityV]);
  useImperativeHandle(ref, () => ({
    clearInput: () => {
      setInputValue("1");
    },
    setInputValue: (newValue: string) => {
      setInputValue(newValue);
    },
    focusInput: () => {
      if (inputRef.current) {
        (inputRef.current as HTMLInputElement).focus();
      }
    }
  }));

  const setQuantityValue = (val: string) => {
    try {
      setInputValue(val);
    } catch (error) {
      setQuantityV("1");
    }
  };

  const setInputValue = (val: string) => {
    if (val) {
      try {
        const num = parseInt(val);
        if (num < 1) {
          setQuantityV("");
        } else {
          setQuantityV(`${num}`);
        }
      } catch (error) {
        setQuantityV("1");
      }
    } else {
      setQuantityV("");
    }
  };

  const addQuantity = (e: any) => {
    e.stopPropagation();
    if (!orderable) return;
    setFocused(true);
    if (!quantityV || quantityV === "0") {
      setQuantityV("1");
      return;
    }
    const quantity = parseInt(quantityV);
    if (quantity === 999) {
      return;
    }
    setQuantityV(`${quantity + 1}`);
  };
  const subQuantity = (e: any) => {
    e.stopPropagation();
    if (!orderable) return;
    setFocused(true);
    if (!quantityV) return;
    if (quantityV === "1" || quantityV === "0") return;
    const quantity = parseInt(quantityV);
    if (quantity < 1) return;
    if (quantity !== 1) {
      setQuantityV(`${quantity - 1}`);
    }
  };
  let editorClass = orderable
    ? `qtyEditorWrapper`
    : "qtyEditorWrapper disabled";
  editorClass = focused ? `${editorClass} focused` : editorClass;

  return (
    <div
      className={editorClass}
      onFocus={() => {
        orderable && setFocused(true);
      }}
      onBlur={() => {
        orderable && setFocused(false);
      }}
    >
      <input
        type="number"
        className="qtyInput"
        disabled={!orderable}
        ref={inputRef}
        value={quantityV}
        onFocus={(e) => {
          orderable && setFocused(true);
        }}
        onBlur={() => {
          orderable && setFocused(false);
        }}
        onChange={(e) => setQuantityValue(e.target.value)}
      />
      <button
        className="plusQtyBtn"
        onClick={addQuantity}
        id="plusQty"
        disabled={!orderable}
        onBlur={() => {
          orderable && setFocused(false);
        }}
      >
        <CaretUpOutlined />
      </button>
      <button
        className="minusQtyBtn"
        onClick={subQuantity}
        disabled={!orderable}
        onBlur={() => {
          orderable && setFocused(false);
        }}
        id="minusQty"
      >
        <CaretDownOutlined />
      </button>
    </div>
  );
});

export default CartCounter;